export default function TempControl() {
    return(
        <div>Temperature</div>
    )
};
